import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class GradeAPI extends BaseAPI {}

export default new GradeAPI('v1/grades', 'Grade', getApiUrl(apis.CommonAPI))
